<script setup lang="ts">
const props = defineProps({
  isDisabled: {
    type: Boolean,
    default: () => false,
  },
});
//#region emits
const emit = defineEmits(['click']);
//#endregion

//#region methods
const handleClick = (event: PointerEvent) => {
  emit('click', event);
};
//#endregion
</script>

<template>
  <div
    :class="[
      'add-button',
      {'add-button_disabled': isDisabled}
    ]"
    @click="handleClick"
  >
    <UiIcon
      size="14px"
      name="plus"
      class="t:mr-4"
      color="var(--text-primary)"
    />
    <div class="add-button__text">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.add-button{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
  color: var(--text-primary);
  border: 1px dashed var(--border-focused);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: var(--background-brand-subtle);
  }
  &__text {
    font-size: 14px;
    font-weight: 700;
    line-height: 30px;
  }
  &_disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
